 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import COPYRIGHT from '@/components/copyright'
 import TITLE from '@/components/title'
 import FM from '@/components/fm'
 import TOC from '@/components/toc'
 import DED from '@/components/ded'
 import ACK from '@/components/ack'
 import CHAPTER1 from '@/components/chapter1'
 import CHAPTER11 from '@/components/chapter11'
 import CHAPTER12 from '@/components/chapter12'
 import CHAPTER13 from '@/components/chapter13'
 import CHAPTER14 from '@/components/chapter14'
 import CHAPTER2 from '@/components/chapter2'
 import CHAPTER21 from '@/components/chapter21'
 import CHAPTER22 from '@/components/chapter22'
 import CHAPTER23 from '@/components/chapter23'
 import CHAPTER24 from '@/components/chapter24'
 import CHAPTER3 from '@/components/chapter3'
 import CHAPTER31 from '@/components/chapter31'
 import CHAPTER32 from '@/components/chapter32'
 import CHAPTER33 from '@/components/chapter33'
 import CHAPTER34 from '@/components/chapter34'
 import CHAPTER4 from '@/components/chapter4'
 import CHAPTER41 from '@/components/chapter41'
 import CHAPTER42 from '@/components/chapter42'
 import CHAPTER43 from '@/components/chapter43'
 import CHAPTER44 from '@/components/chapter44'
 import CHAPTER5 from '@/components/chapter5'
 import CHAPTER51 from '@/components/chapter51'
 import CHAPTER52 from '@/components/chapter52'
 import CHAPTER53 from '@/components/chapter53'
 import CHAPTER54 from '@/components/chapter54'
 import CHAPTER6 from '@/components/chapter6'
 import CHAPTER61 from '@/components/chapter61'
 import CHAPTER62 from '@/components/chapter62'
 import CHAPTER63 from '@/components/chapter63'
 import CHAPTER64 from '@/components/chapter64'
 import CHAPTER7 from '@/components/chapter7'
 import CHAPTER71 from '@/components/chapter71'
 import CHAPTER72 from '@/components/chapter72'
 import CHAPTER73 from '@/components/chapter73'
 import CHAPTER74 from '@/components/chapter74'
 import CHAPTER8 from '@/components/chapter8'
 import CHAPTER81 from '@/components/chapter81'
 import CHAPTER82 from '@/components/chapter82'
 import CHAPTER83 from '@/components/chapter83'
 import CHAPTER84 from '@/components/chapter84'
 import CHAPTER9 from '@/components/chapter9'
 import CHAPTER91 from '@/components/chapter91'
 import CHAPTER92 from '@/components/chapter92'
 import CHAPTER93 from '@/components/chapter93'
 import CHAPTER94 from '@/components/chapter94'
 import CHAPTER10 from '@/components/chapter10'
 import CHAPTER101 from '@/components/chapter101'
 import CHAPTER102 from '@/components/chapter102'
 import CHAPTER103 from '@/components/chapter103'
 import CHAPTER104 from '@/components/chapter104'
 import AFTERWORD from '@/components/afterword'
 import ATA from '@/components/ata'
 import TY from '@/components/ty'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/ded",
 			"name" : "ded",
 			"component" : DED
 		},
 		{
 			"path" : "/ack",
 			"name" : "ack",
 			"component" : ACK
 		},
 		{
 			"path" : "/chapter1",
 			"name" : "chapter1",
 			"component" : CHAPTER1
 		},
 		{
 			"path" : "/chapter11",
 			"name" : "chapter11",
 			"component" : CHAPTER11
 		},
 		{
 			"path" : "/chapter12",
 			"name" : "chapter12",
 			"component" : CHAPTER12
 		},
 		{
 			"path" : "/chapter13",
 			"name" : "chapter13",
 			"component" : CHAPTER13
 		},
 		{
 			"path" : "/chapter14",
 			"name" : "chapter14",
 			"component" : CHAPTER14
 		},
 		{
 			"path" : "/chapter2",
 			"name" : "chapter2",
 			"component" : CHAPTER2
 		},
 		{
 			"path" : "/chapter21",
 			"name" : "chapter21",
 			"component" : CHAPTER21
 		},
 		{
 			"path" : "/chapter22",
 			"name" : "chapter22",
 			"component" : CHAPTER22
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js